import script from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"
export * from "./TrocarPlano.vue?vue&type=script&setup=true&lang=js"

import "./TrocarPlano.vue?vue&type=style&index=0&id=321d18dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321d18dc"]])

export default __exports__